import { usePost } from "./use-post";
import { GraphqlError, GraphqlAccessDeniedError } from "./errors";
import { useGetContext } from "@onefront/forrestjs-react-root";

const getQuery = (query) => {
  return typeof query === "string" ? query : query.loc.source.body;
};

export const useMutation = (
  query,
  { graphqlEndpoint, variables = {}, lazy = true, ...options } = {}
) => {
  const defaultEndpoint = useGetContext("one.rest.graphql.baseUrl");
  const endpoint = graphqlEndpoint || defaultEndpoint;

  const {
    data,
    fetch: postFetch,
    ...request
  } = usePost(
    endpoint,
    {
      query: getQuery(query),
      variables
    },
    {
      lazy,
      stateless: options?.stateless ?? false,
      onResponse: (response) => {
        if (response.data.errors && response.data.errors.length) {
          const [error] = response.data.errors;

          // Detect an AccessError
          // (will trigger implicit retry)
          if (error.extensions.code === "access-denied") {
            throw new GraphqlAccessDeniedError(error.message, response);
          }

          // Generic GraphQL Error
          throw new GraphqlError(error.message, response);
        }
      },
      onError: (error) => error instanceof GraphqlAccessDeniedError,
      ...options
    }
  );

  const fetch = (variables = {}) =>
    postFetch({
      data: { query: getQuery(query), variables }
    });

  return {
    ...request,
    fetch,
    data: data && data.data ? data.data : null
  };
};
